module.exports = __webpack_public_path__ + "static/fonts/Arita-dotumSB.275df27.ttf";